.source {
  border: 1px solid var(--border-strong);
  border-radius: 0.375rem;
  background: var(--surface-raised);
  padding: 0.5rem 0.75rem;
}

.title {
  margin: 0 0 0.5rem;
  font-size: 1rem;
}

.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
}

.tabs {
  display: flex;
  gap: 0.25rem;
}

.tab {
  padding: 0.25rem 0.75rem;
  border: 1px solid var(--border-strong);
  border-radius: 0.375rem;
  background: var(--surface);
  color: inherit;
  cursor: pointer;
}

.tab[aria-selected="true"] {
  font-weight: 600;
  border-color: var(--text);
}

.notice {
  min-height: 1.25rem;
  color: var(--text-muted);
}

.hint {
  margin: 0.5rem 0;
  color: var(--text-muted);
}

.code {
  max-height: 24rem;
  margin: 0.5rem 0 0;
  overflow: auto;
  font-size: 0.875rem;
  white-space: pre;
}

/* Token classes from highlight.js; colours come from the theme tokens, never inline styles. */
.code :global(.hljs-keyword),
.code :global(.hljs-selector-tag),
.code :global(.hljs-tag) {
  font-weight: 600;
}

.code :global(.hljs-string),
.code :global(.hljs-attr),
.code :global(.hljs-number) {
  color: var(--text-accent, var(--text));
}

.code :global(.hljs-comment) {
  color: var(--text-muted);
  font-style: italic;
}
